import LaptopSidebar from './laptopSidebar';

export default LaptopSidebar;
